import {useState} from 'react';

export default function ForgotPasswordScreen() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        await fetch('/api/v1/auth/forgot-password', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email}),
        });
        setSubmitted(true);
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Forgot password</h2>
                {submitted ? (
                    <p className="login-success">
                        If that email is registered, a reset link has been sent.
                    </p>
                ) : (
                    <>
                        <input
                            className="login-input"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            autoFocus
                        />
                        <button
                            className="login-button"
                            type="submit"
                            disabled={!email}
                        >Send reset link</button>
                    </>
                )}
                <p className="login-register-link">
                    <a href="/?signin">Back to sign in</a>
                </p>
            </form>
        </div>
    );
}
